import React from "react";
import { LANDING } from "../../constants/testIds";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-ivory text-chocolate py-16 px-6 md:px-12 border-t border-chocolate/10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
        
        {/* Col 1: Logo and brand statement */}
        <div className="md:col-span-6 space-y-6">
          <h3 
            onClick={scrollToTop}
            className="text-2xl font-editorial tracking-[0.15em] cursor-pointer text-bordeaux hover:text-bordeaux-hover transition-colors"
          >
            BACK TO YOU™
          </h3>
          <p className="text-sm font-light leading-relaxed text-chocolate/70 max-w-md">
            Un brand dedicato alle donne che desiderano liberarsi definitivamente da relazioni tossiche, interrompere schemi emotivi distruttivi e ritrovare il proprio valore. Non insegniamo tecniche di seduzione, ti guidiamo a tornare al centro della tua vita.
          </p>
        </div>

        {/* Col 2: Navigation Links */}
        <div className="md:col-span-3 space-y-4">
          <h4 className="text-xs font-semibold tracking-widest text-bordeaux uppercase">NAVIGAZIONE</h4>
          <ul className="space-y-2 text-sm font-light">
            <li>
              <a href="#il-problema" className="hover:text-bordeaux text-chocolate/80 transition-colors">Il Problema</a>
            </li>
            <li>
              <a href="#metodo" className="hover:text-bordeaux text-chocolate/80 transition-colors">Il Metodo Feminine Return™</a>
            </li>
            <li>
              <a href="#chi-sono" className="hover:text-bordeaux text-chocolate/80 transition-colors">Chi Sono</a>
            </li>
            <li>
              <a href="#faq" className="hover:text-bordeaux text-chocolate/80 transition-colors">Domande Frequenti</a>
            </li>
            <li>
              <a href="#community" className="hover:text-bordeaux text-chocolate/80 transition-colors">La Community</a>
            </li>
          </ul>
        </div>

        {/* Col 3: Disclaimer & Contact */}
        <div className="md:col-span-3 space-y-4">
          <h4 className="text-xs font-semibold tracking-widest text-bordeaux uppercase">CONTATTI & NOTE</h4>
          <p className="text-xs text-chocolate/60 leading-relaxed font-light">
            BACK TO YOU™ di Giulia <br />
            Email: info@backtoyou.it <br />
            Milano, Italia
          </p>
          <p className="text-[10px] text-chocolate/40 leading-relaxed font-light">
            Disclaimer: I contenuti di questo sito non costituiscono consulenza medica, psicologica o terapeutica. Il percorso è di natura formativa e di coaching.
          </p>
        </div>

      </div>

      <div className="max-w-7xl mx-auto border-t border-chocolate/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center text-[10px] text-chocolate/40 gap-4 font-mono">
        <span>© 2026 BACK TO YOU™ — TUTTI I DIRITTI RISERVATI.</span>
        <span>DESIGN PREMIUM • STILE EDITORIALE</span>
      </div>
    </footer>
  );
}
